/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * キーワード
 * @export
 * @interface KijinetaTag
 */
export interface KijinetaTag {
    /**
     * タグのID
     * @type {number}
     * @memberof KijinetaTag
     */
    kijinetaTagId: number;
    /**
     * タグの名前
     * @type {string}
     * @memberof KijinetaTag
     */
    kijinetaTag: string;
}

export function KijinetaTagFromJSON(json: any): KijinetaTag {
    return KijinetaTagFromJSONTyped(json, false);
}

export function KijinetaTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): KijinetaTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kijinetaTagId': json['kijineta_tag_id'],
        'kijinetaTag': json['kijineta_tag'],
    };
}

export function KijinetaTagToJSON(value?: KijinetaTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kijineta_tag_id': value.kijinetaTagId,
        'kijineta_tag': value.kijinetaTag,
    };
}

